import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

const NavBarStyled = styled.div`
  display: flex;
`;

const skinStyles = ({ theme: { components } }) => {
  return css`
    background: ${_.get(components, 'SegmentedButton.skins.primary.bg')};
    border: 1px solid ${_.get(components, 'SegmentedButton.skins.primary.border')};
    border-right-width: 0;

    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-right-width: 1px;
    }

    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    &.active {
      background: ${_.get(components, 'SegmentedButton.skins.primary.bgActive')};
      border-color: ${_.get(components, 'SegmentedButton.skins.primary.borderActive')};
    }

    &.active + & {
      border-left-color: ${_.get(components, 'SegmentedButton.skins.primary.borderActive')};
    }

    &:hover {
      background: ${_.get(components, 'SegmentedButton.skins.primary.bgActive')};
      border-color: ${_.get(components, 'SegmentedButton.skins.primary.borderActive')};
      & + & {
        border-left-color: ${_.get(components, 'SegmentedButton.skins.primary.borderActive')};
      }
    }
  `;
};

const sizeStyles = ({ theme }) => {
  return css`
    height: ${_.get(theme, 'components.SegmentedButton.sizes.M.height')};
    padding: 0 ${_.get(theme, 'components.SegmentedButton.sizes.M.padding')};
  `;
};

const NavLinkStyled = styled(NavLink)`
  background: #ffffff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-decoration: none;
  color: var(--blackBat);
  ${skinStyles}
  ${sizeStyles}
`;

export { NavBarStyled, NavLinkStyled };
